/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect, useRef, useState } from "react";

const styles = {
  expanderPanel: css`
  `,

  bar: css`
    background-color: #eee;
    cursor: pointer;
    background: rgb(218, 221, 224);
    background: -moz-linear-gradient(
      0deg,
      rgba(218, 221, 224, 1) 0%,
      rgba(242, 242, 244, 1) 100%
    );
    background: -webkit-linear-gradient(
      0deg,
      rgba(218, 221, 224, 1) 0%,
      rgba(242, 242, 244, 1) 100%
    );
    background: linear-gradient(
      0deg,
      rgba(218, 221, 224, 1) 0%,
      rgba(242, 242, 244, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#dadde0", endColorstr="#f2f2f4", GradientType=1);
    border-color: #a4abb2;
    border-bottom-style: solid;
    border-bottom-width: 1px;

    &:hover:not(.disabled):not(.expanderCurrentSelection) {
      background: rgb(218, 221, 224);
      background: -moz-linear-gradient(
        0deg,
        rgba(218, 221, 224, 1) 50%,
        rgba(242, 242, 244, 1) 100%
      );
      background: -webkit-linear-gradient(
        0deg,
        rgba(218, 221, 224, 1) 50%,
        rgba(242, 242, 244, 1) 100%
      );
      background: linear-gradient(
        0deg,
        rgba(218, 221, 224, 1) 50%,
        rgba(242, 242, 244, 1) 100%
      );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#dadde0", endColorstr="#f2f2f4", GradientType=1);
    }
  `,

  expanderCurrentSelection: css`
    background: #c0c7cf;
  `,

  x: css`
    button {
      border: none;
      padding: none;
      margin: none;

      &:focus {
        outline: none;
      }
    }
  `,

  disabled: css`
    color: silver;
    cursor: default;
  `,

  expander: css`
    display: inline-block;
    padding: 0 5px 5px 5px;
  `,

  rpExpandHandle: css`
    display: block;
    float: right;
    height: 15px;
    width: 15px;
    margin: 5px 5px 0 0;
    list-style-position: outside;
    list-style: none;
    background-position: 0 -5px;
    background-color: transparent;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAH0CAMAAAAdRm3AAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhGRUI3OTFCQUJDNTExRTA5RUUzODAzNkE5RkY3RDc2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhGRUI3OTFDQUJDNTExRTA5RUUzODAzNkE5RkY3RDc2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OEZFQjc5MTlBQkM1MTFFMDlFRTM4MDM2QTlGRjdENzYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OEZFQjc5MUFBQkM1MTFFMDlFRTM4MDM2QTlGRjdENzYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5DE7X0AAAAkFBMVEWkq7Lz1kr89dnh4+Xd4OPf4eTu7/Hv8fLs7u/j5Ofr7O764YVjZWf866/c3uH7553755/878D75ZP76abx8vP644v65JHl5ulfYGJnaWvn6Orp6uxvcXNaW11xc3X64odrbW9WV1mts7n02ltMTU/02l356qhSU1XX2t23vcJOT1H57K2utLr233DLztMAAAC+iU5ZAAAAMHRSTlP//////////////////////////////////////////////////////////////wBipdB4AAABYElEQVR42uzay1KDQBCF4Um8xsG7RiIkCpiYmAvv/3ZOD5BuNpblJpb+ZxFovgKqmKxOjau/jDsobweabV2vnGZVu2ox1CyqcvmgWZZuMLzXDAfuzMYFvtYEPrURvtMEPrcRftQEvrAR9n42m+Wvk8T7wFmWtWM4a9jLlPrIzyFxlBPhl5Akncoh8JMkjPEoPJYU8TfwKKZoDsI3msBHNsKXmsAnNsK3msDHNs7N1+abr+eb3ZVmt3F1ZVasquvSrFh54D8TDMMwDMMwDMMwDMMwDP9x/vV9at7vU3Pbp3of29SuT82ypk3d96mTJJ0W2qfGUftUmd4/3ro+tR1tnzru96kj+lQYhmEYhmEYhmEYhmH4H3G7f7G7Zsbm7rh/Ue/RsX14kk7tM/dj9+6i/86Cbw7DMAzDMAzDMAzD8Lc571/O+2wqjd7YcNxEpKqjazsM2URkKo1uZEl+wp8CDAAMVkVPMF/q0wAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;

    &:hover {
      background-position: 100% -5px;
    }
  `,

  rpExpanded: css`
    background-position: 0 -181px;

    &:hover {
      background-position: 100% -181px;
    }
  `,

  title: css`
    display: inline-block;
    width: 100px;
    vertical-align: top;
    font-weight: bold;
  `,

  description: css`
    width:85%;
    display: inline-block;
    vertical-align: top;
  `,

  country: css`
    display: inline-block;
    width: 180px;
  `,

  displayGroupSpace: css`
    margin-right: 5px;
  `,

  warning: css`
    color: #cc0000;
  `,

  expanderContent: css`
    max-height: 0;
    transition: max-height 0.5s ease;
    overflow-y: hidden;
    border: 1px solid #dbdfe4;
    padding-left: 5px;
  `,

  expanderContentShow: css`
    height: 100%;
    display: block;    
    padding-bottom: 20px;
  `,

  subHeading: css`
   font-weight: normal;
  `
};

export const ExpanderPanel = ( { title, subHeading, isEnabled = true, isExpanded, selectedExpanderPanel, description, children, onExpanded, onSelected }: { title: string; subHeading?: string; isEnabled?: boolean; isExpanded?: boolean; selectedExpanderPanel?: string; description?: React.ReactNode; children: React.ReactNode; onExpanded: ( isExpanded: boolean ) => void; onSelected?: ( title: string ) => void; } ): JSX.Element => {
  const [ elementHeight, setElementHeight ] = useState( 0 );
  const contentRef = useRef<HTMLDivElement>( null );

  useEffect( () => {
    if ( isExpanded && contentRef.current ) {
      setElementHeight( contentRef.current.getBoundingClientRect().height );
    } else {
      setElementHeight( 0 );
    }
  }, [ isExpanded ] );

  useEffect( () => {
    if ( !contentRef.current ) return;
    const div = contentRef.current;

    const observer = new ResizeObserver( ( entries ) => {
      for ( const entry of entries ) {
        if ( entry.target === div ) {
          setElementHeight( entry.contentRect.height );
        }
      }
    } );

    observer.observe( div );

    return () => {
      observer.unobserve( div );
      observer.disconnect();
    };
  }, [] );

  return (
    <div css={ styles.expanderPanel }>
      <div css={ [ styles.bar, isEnabled ? undefined : styles.disabled, title === selectedExpanderPanel ? styles.expanderCurrentSelection : undefined ] } onClick={ () => { isEnabled && onExpanded( !isExpanded ); isEnabled && onSelected && onSelected( title ); } }>
        <div css={ styles.expander }>
          <div>
            <span css={ [ styles.rpExpandHandle, isExpanded ? styles.rpExpanded : undefined ] }></span>
          </div>
        </div>
        <div css={ styles.title }>{ title }{ subHeading && <div css={ styles.subHeading }>{ subHeading }</div> }</div>
        { description && <div css={ styles.description }>{ description }</div> }
      </div>

      <div css={ [ styles.expanderContent, isEnabled && isExpanded ? styles.expanderContentShow : undefined, isEnabled && isExpanded ? `max-height: ${ elementHeight }px` : undefined ] }>
        <div ref={ contentRef }>
          { isEnabled && children }
        </div>
      </div>
    </div >
  );
};
